export default{

    
  "hero_subtitle": "محل – منصة توريد الأغذية B2B",
  "hero_title_1": "ربط المطاعم",
  "hero_title_2": "مع",
  "hero_desc": "قم بتبسيط عمليات الشراء وإدارة الطلبات بكفاءة وبناء شراكات طويلة الأمد — كل ذلك في منصة واحدة.",
  "get_started": "ابدأ مع محل",

  "word1": "موردون موثوقون",
  "word2": "مكونات طازجة",
  "word3": "أسعار تنافسية",
  "word4": "توصيل موثوق",
}